// extracted by mini-css-extract-plugin
export default {"container":"_15fp-P","content":"_2Ft_WO","contentWrapper":"_2C0r1G"};